import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import ET3Div from "../../../../core/et3-div";
import Et3TextInput from "../../../../core/et3-input/et3-text-input";
import i18n from "../../../../constants/i18n";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import getUserStore from "../../../../stores/user-store";

const GiveSubscriptionsForm = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="row"
      justifyContent="flex-start"
      alignItems="flex-start"
      withShadow={false}
      width={300}
      height={75}
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <Et3TextInput
        size="MEDIUM"
        withShadow={true}
        icon={faUser}
        type={"number"}
        label={i18n.get("USER_ID")}
        placeHolder={i18n.get("USER_ID")}
        value={getUserStore().userIdInput.get()}
        onChoose={(value: number) => {
          getUserStore().setUserIDInput(value);
        }}
        onBlur={() => {}}
        style={{}}
        onEnter={() => {}}
      />
    </ET3Div>
  );
});

export default GiveSubscriptionsForm;
